import React, { useState } from "react";
import Allorders from "./Signals/Orders";
import Openposition from "./TradeHistory/openposition";
import Closedposition from "./TradeHistory/closeposition";

const Orders = () => {
  const [activeTab, setActiveTab] = useState("order"); // default tab

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "order":
        return <Allorders />;
      case "orderHistory":
        return <Openposition />;
      case "tradeHistory":
        return <Closedposition />;
      default:
        return null;
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="wrapper-data">
          {/* Custom Tabs Navigation with Sliding Effect */}
          <div className="tab-container-wrapper">
            <div className="tabs">
              <input
                type="radio"
                id="radio-1"
                name="tabs"
                checked={activeTab === "order"}
                onChange={() => handleTabChange("order")}
              />
              <label
                className="tab"
                htmlFor="radio-1"
                onClick={() => handleTabChange("order")}
              >
                All Order
              </label>

              <input
                type="radio"
                id="radio-2"
                name="tabs"
                checked={activeTab === "orderHistory"}
                onChange={() => handleTabChange("orderHistory")}
              />
              <label
                className="tab"
                htmlFor="radio-2"
                onClick={() => handleTabChange("orderHistory")}
              >
                Open position
              </label>

              <input
                type="radio"
                id="radio-3"
                name="tabs"
                checked={activeTab === "tradeHistory"}
                onChange={() => handleTabChange("tradeHistory")}
              />
              <label
                className="tab"
                htmlFor="radio-3"
                onClick={() => handleTabChange("tradeHistory")}
              >
                Closed position
              </label>

              <span
                className={`glider ${
                  activeTab === "order"
                    ? "glider-1"
                    : activeTab === "orderHistory"
                    ? "glider-2"
                    : "glider-3"
                }`}
              ></span>
            </div>
          </div>

          {/* Tab Content */}
          <div className="content-wrapper">{renderTabContent()}</div>
        </div>
      </div>

      {/* Custom CSS Styles */}
      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

        :root {
          --primary-color: #7c3aed;
          --secondary-color: #e6eef9;
        }

        .tab-container-wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-bottom: 2rem;
        }

        .tabs {
          display: flex;
          position: relative;
          background-color: #fff;
          box-shadow: 0 0 1px 0 rgba(124, 58, 237, 0.15),
            0 6px 12px 0 rgba(124, 58, 237, 0.15);
          padding: 0.5rem;
          border-radius: 99px;
          font-family: "Inter", sans-serif;
          transform: scale(0.85);
        }

        .tabs * {
          z-index: 2;
        }

        input[type="radio"] {
          display: none;
        }

        .tab {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          width: 160px;
          font-size: 0.875rem;
          font-weight: 500;
          border-radius: 99px;
          cursor: pointer;
          transition: color 0.15s ease-in;
          color: #6b7280;
          position: relative;
        }

        .notification {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.25rem;
          height: 1.25rem;
          margin-left: 0.375rem;
          border-radius: 50%;
          background-color: var(--secondary-color);
          transition: 0.15s ease-in;
          font-size: 0.625rem;
          font-weight: 600;
        }

        input[type="radio"]:checked + label {
          color: var(--primary-color);
        }

        input[type="radio"]:checked + label > .notification {
          background-color: var(--primary-color);
          color: #fff;
        }

        .glider {
          position: absolute;
          display: flex;
          height: 44px;
          width: 160px;
          background-color: var(--secondary-color);
          z-index: 1;
          border-radius: 99px;
          transition: 0.25s ease-out;
          transform: translateX(0);
        }

        .glider-1 {
          transform: translateX(0);
        }

        .glider-2 {
          transform: translateX(100%);
        }

        .glider-3 {
          transform: translateX(200%);
        }

        .content-wrapper {
          padding: 2rem;
          border-radius: 12px;
          background-color: white;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
            0 1px 2px 0 rgba(0, 0, 0, 0.06);
          min-height: 300px;
        }

        .tab-content {
          animation: fadeIn 0.3s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsive Design */
        @media (max-width: 700px) {
          .tabs {
            transform: scale(0.8);
          }

          .tab {
            width: 160px;
            font-size: 0.9rem;
          }

          .glider {
            width: 160px;
          }
        }

        @media (max-width: 500px) {
          .tabs {
            transform: scale(0.7);
            flex-direction: column;
            padding: 0.5rem;
          }

          .tab {
            width: 100%;
            margin-bottom: 0.5rem;
          }

          .glider {
            display: none; /* Hide glider on mobile for better UX */
          }
        }
      `}</style>
    </div>
  );
};

export default Orders;
